import useDefinedContext from "hooks/useDefinedContext";
import ChartScalesContext from "../contexts/ChartScalesContext";

function useYScaleById(scaleId: string) {
  const scales = useDefinedContext(ChartScalesContext);

  return scales.y[scaleId];
}
export default useYScaleById;
